import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SmartGridNode, SmartTileTypes } from "@common/build/types";
import EditableInfo from "../../EditableInfo";
import OliverText, { TextType } from "@builder/components/general/OliverText";
import "./style.scss";
import Toggle from "@builder/components/general/Toggle";
import { setActiveNode, updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
// import CheckboxDropdown from "@builder/components/general/CheckboxDropdown";
// import { Role } from "@builder/types/roles.type";
// import { useGetRolesQuery } from "@builder/store/slices/dataApiSlices/rolesApiSlice";
// import { skipToken } from "@reduxjs/toolkit/query";

const getNewAllowedTypes = (allowedTypes: SmartTileTypes[], tileType: SmartTileTypes, checked: boolean) => {
    if (checked) return [...allowedTypes, tileType];
    if (!checked) {
        if (tileType === SmartTileTypes.PRODUCT) {
            return allowedTypes.filter(type => type !== SmartTileTypes.PRODUCT && type !== SmartTileTypes.CATEGORY);
        } else {
            return allowedTypes.filter(type => type !== tileType);
        }
    }
};

// const getNewAllowedRoles = (allRoles: Role[], allowedRoles: string[], role: Role) => {
//     if (allowedRoles.length > 0) {
//         if (allowedRoles[0] === "*") {
//             return allRoles.reduce((acc: string[], r: Role) => {
//                 if (r._id !== role._id) acc.push(r._id);
//                 return acc;
//             }, []);
//         } else {
//             if (allowedRoles.includes(role._id)) {
//                 return allowedRoles.filter(r => r !== role._id);
//             } else {
//                 return [...allowedRoles, role._id];
//             }
//         }
//     }
//     return [role.name];
// };

const EditSmartGrid = () => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode) as SmartGridNode;
    const activeNode = useAppSelector(state => state.builder.activeNode);
    // const { company, isOrg, data } = useAppSelector(state => state.storeData);
    // const { company: activeCompany } = data || {};
    // const { data: roles } = useGetRolesQuery(
    //     activeCompany?._id ? { companyId: activeCompany._id, ...(isOrg && { organizationId: company?._id }) } : skipToken
    // );

    if (!selectedNode) return null;

    const { smartGrid } = selectedNode;
    const { allowedTypes } = smartGrid || {};

    return (
        <SidebarCollapse title="Setup">
            <div className="edit-smart-grid">
                <EditableInfo header="smartGridInfo1" body="smartGridInfo2" body2="smartGridInfo3" />
                <div className="edit-smart-grid-divider"></div>
                <div className="edit-smart-grid-inputs-wrapper">
                    <Toggle
                        label="Show save layout button"
                        checked={activeNode === selectedNode.id}
                        callback={(checked: boolean) => {
                            dispatch(setActiveNode(checked ? selectedNode.id : null));
                        }}
                    />
                    <OliverText type={TextType.BODY_4}>Available tile types:</OliverText>
                    <div className="edit-smart-grid-inputs">
                        {Object.values(SmartTileTypes)
                            .filter(type => type !== SmartTileTypes.BACK && type !== SmartTileTypes.EMPTY)
                            .map(type => (
                                <Toggle
                                    key={type}
                                    label={type}
                                    checked={allowedTypes?.includes(type) || false}
                                    callback={(checked: boolean) =>
                                        dispatch(
                                            updateNodeProperty({
                                                propertyPath: ["smartGrid", "allowedTypes"],
                                                value: getNewAllowedTypes(allowedTypes || [], type, checked)
                                            })
                                        )
                                    }
                                    disabled={type === SmartTileTypes.CATEGORY && !allowedTypes?.includes(SmartTileTypes.PRODUCT)}
                                />
                            ))}
                    </div>
                </div>
                {/* <div className="edit-smart-grid-divider"></div>
                <div className="edit-smart-grid-permissions">
                    <OliverText type={TextType.BODY_4}>Select which roles can edit grid:</OliverText>
                    <CheckboxDropdown
                        options={
                            roles?.map(role => ({
                                ...role,
                                checked: allowedRoles?.includes(role._id) || allowedRoles?.[0] === "*"
                            })) || []
                        }
                        callback={checkedRole =>
                            dispatch(
                                updateNodeProperty({
                                    propertyPath: ["smartGrid", "allowedRoles"],
                                    value: getNewAllowedRoles(roles || [], allowedRoles || [], checkedRole)
                                })
                            )
                        }
                        getLabel={role => role.name}
                        replaceSelectedLabel={
                            allowedRoles && (allowedRoles[0] === "*" || (roles && allowedRoles.length === roles.length))
                                ? "All roles selected"
                                : `${allowedRoles?.length} roles selected`
                        }
                    />
                </div> */}
            </div>
        </SidebarCollapse>
    );
};

export default EditSmartGrid;
